module.exports = __webpack_public_path__ + "img/megamillions_ad2.917cd964.png";